export const PLAN_NAMES_MAP = {
  free: 'Free',
  creator: 'Creator',
  professional: 'Professional',
  enterprise: 'Enterprise',
}